import styled from 'styled-components';
import { useUpdateSearchParams } from '../../../../hooks';
import { useSelector } from 'react-redux';

const StyledButton = styled.div`
  width: 80px;
  height: 32px;
  border-radius: 6px;
  background: #3994de;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const accessJobs = ['Admin', 'Salesman', 'Manager'];

export const AdminPlaceOfferButton = () => {
  const user = useSelector((state: any) => state.user.user);
  const updateSearchParams = useUpdateSearchParams();

  if (!user?.job_title || !accessJobs.includes(user.job_title)) {
    return null;
  }

  return (
    <StyledButton onClick={() => updateSearchParams({ place_offer_opened: 'true' })}>Make offer</StyledButton>
  );
};
